import React from 'react';
import { IconProps } from '.';

const SvgCircleInfoFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1Zm-.75 9.5v7h1.5v-7h-1.5Zm0-4v2h1.5v-2h-1.5Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleInfoFill;
